module.exports = __webpack_public_path__ + "img/bg_image_home.a409a5c0.png";